import React from "react";
import NavBar from "../components/homePage/navBar";
import Warehouse from "../components/warehouses/Warehouse";
const WarehousePage: React.FC = () => {
  return (
    <div>
      <NavBar />
      <Warehouse />
    </div>
  );
};

export default WarehousePage;
